// Vue
import { Component, Watch, Prop } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { Api } from "../../../api";
import { Haendlersuche } from "../../../components/haendlersuche/Haendlersuche";
import { AbhHandlersuche } from "../../../common/interfaces/unimog/AbhHandlersuche";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Haendlersuche,
  },
})
export class HaendlersucheModule extends ModuleBase {
  private abhId: string | null = null;

  private points: H.geo.IPoint[] = [];

  private abhData: AbhHandlersuche | null = null;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.abhId = urlParams.get("abhId");
  }

  public mounted() {
    this.loadHaendler();
    this.loadAbh();
  }

  public async loadHaendler() {
    let result = await Api.haendlersuche.getHaendler(this.sparte);
    let dataPoints: H.clustering.DataPoint[] = [];
    result.forEach((entry) => {
      dataPoints.push(
        new H.clustering.DataPoint(
          entry.location.lat,
          entry.location.lng,
          1,
          entry
        )
      );
    });

    this.points = dataPoints;
  }

  get sparte() {
    return this.instance["sparte"];
  }

  public async loadAbh() {
    if (this.abhId) {
      this.abhData = await Api.haendlersuche.getAbh(this.abhId, this.sparte);
    }
  }
}
